<!-- src/app/work-order-numbers/components/work-order-import/work-order-import.component.html -->

<planning-top-nav></planning-top-nav>

<div class="import-card">

  <h2>Import Work Order Numbers</h2>
  <p class="subtitle">Upload a completed work order template to import records.</p>

  <div class="dropzone" [class.active]="selectedFile" (dragover)="$event.preventDefault()" (drop)="handleDrop($event)">
    <input type="file" accept=".xlsx,.xls,.csv" hidden #fileInput id="fileInput" (change)="onFileSelected($event)" />

    <div *ngIf="!selectedFile" class="dropzone-content">
      <p>Drag & drop file here</p>
      <span>or</span>
      <button type="button" (click)="fileInput.click()">Browse</button>
    </div>

    <div *ngIf="selectedFile" class="dropzone-content">
      <p class="filename">{{ selectedFile.name }}</p>
      <div class="dropzone-actions">
        <button type="button" class="change-btn" (click)="fileInput.click()">Change File</button>
        <button type="button" class="remove-btn" (click)="removeFile()">Remove</button>
      </div>
    </div>
  </div>

  <button class="upload-btn" [disabled]="!selectedFile || isLoading" (click)="upload()">
    <ng-container *ngIf="!isLoading">Upload</ng-container>
    <ng-container *ngIf="isLoading">
      <div class="spinner"></div> Uploading...
    </ng-container>
  </button>

  <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>

</div>

<!-- Upload Logs Card -->
<div class="upload-logs" *ngIf="logs.length">
  <h3>Upload Logs</h3>

  <div class="log-entry" *ngFor="let log of logs">
    <div class="log-summary" (click)="activeLog = log">
      <div class="status-icon" [ngClass]="{
            'success': log.successCount === log.totalRows,
            'partial': log.successCount > 0 && log.successCount < log.totalRows,
            'fail': log.successCount === 0
          }">
        <span *ngIf="log.successCount === log.totalRows">✔️</span>
        <span *ngIf="log.successCount > 0 && log.successCount < log.totalRows">⚠️</span>
        <span *ngIf="log.successCount === 0">❌</span>
      </div>
      <div class="summary-info">
        <div class="timestamp">{{ log.timestamp | date:'short' }}</div>
        <div class="summary-stats">
          Total: <strong>{{ log.totalRows }}</strong> |
          Imported: <strong>{{ log.successCount }}</strong> |
          Duration: <strong>{{ log.durationMs }}ms</strong>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for log details -->
<div class="log-modal" *ngIf="activeLog">
  <div class="modal-backdrop" (click)="activeLog = null"></div>

  <div class="modal-content">
    <button class="close-btn" (click)="activeLog = null">&times;</button>

    <div class="modal-header">
      <h3>Upload Details</h3>
      <p class="timestamp">{{ activeLog.timestamp | date:'short' }}</p>
    </div>

    <div class="modal-meta">
      <div><strong>Uploaded By:</strong> {{ activeLog.uploadedBy }}</div>
      <div><strong>Total Rows:</strong> {{ activeLog.totalRows }}</div>
      <div><strong>Imported:</strong> {{ activeLog.successCount }}</div>
      <div><strong>Not Imported:</strong> {{ activeLog.totalRows - activeLog.successCount }}</div>
    </div>

    <div class="modal-body">

      <h4>Upload Result</h4>
      <div class="invalid-fields" *ngIf="aggregatedErrors.length">
        <div class="field" *ngFor="let e of aggregatedErrors">
          <strong>{{ e.field }}</strong>:
          <span class="value" *ngFor="let v of e.values; let last = last">
            "{{ v }}"<span *ngIf="!last">, </span>
          </span>
        </div>
      </div>

      <ng-container *ngIf="activeLog.createdWorkOrders?.length">
        <h4>Work Orders Created</h4>

        <div class="failed-row" *ngFor="let w of activeLog.createdWorkOrders">
          <div class="row-header">
            <span class="employee-number">{{ w.won }} ({{ w.project }})</span>
            <span class="row-index">#{{ w.id }}</span>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>